module.exports = {
	"countries": [
		{
			"name": "Afganistan",
			"key": "AF",
			"flag": "afg"
		},
		{
			"name": "Australia",
			"key": "AU",
			"flag": "aus"
		},
		{
			"name": "Bangladesh",
			"key": "BD",
			"flag": "ban"
		},
		{
			"name": "Canada",
			"key": "CA",
			"flag": "CAN"
		},
		{
			"name": "UK",
			"key": "GB",
			"flag": "uk"
		},
		{
			"name": "Hong Kong",
			"key": "HK",
			"flag": "hk"
		},
		{
			"name": "India",
			"key": "IN",
			"flag": "ind"
		},
		{
			"name": "Ireland",
			"key": "IE",
			"flag": "ire"
		},
		{
			"name": "Kenya",
			"key": "KE",
			"flag": "ken"
		},
		{
			"name": "Nepal",
			"key": "NP",
			"flag": "nep"
		},
		{
			"name": "Netherlands",
			"key": "NL",
			"flag": "nl"
		},
		{
			"name": "New Zealand",
			"key": "NZ",
			"flag": "nz"
		},
		{
			"name": "Pakistan",
			"key": "PK",
			"flag": "pak"
		},
		{
			"name": "South Africa",
			"key": "ZA",
			"flag": "rsa"
		},
		{
			"name": "Sri Lanka",
			"key": "LK",
			"flag": "sl"
		},
		{
			"name": "Scotland",
			"key": "SCT",
			"flag": "SCT"
		},
		{
			"name": "United Arab Emirates",
			"key": "AE",
			"flag": "UAE"
		},
		{
			"name": "West Indies",
			"key": "WI",
			"flag": "WI"
		},
		{
			"name": "Zimbabwe",
			"key": "ZW",
			"flag": "ZIM"
		},
		{
			"name": "Global",
			"key": "GLOBAL",
			"flag": "global"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/app/config/countries.json
// module id = 483
// module chunks = 0